// @flow
import * as React from 'react';
import { Box } from 'grommet';


type Props = {
    actions?: React.Node,
    children?: React.Node,
    background?: string,
};

const BottomContainer = (props: Props) => {
    const { actions, children, background } = props;

    return (
        <Box
            height={{ min: 'auto' }}
            flex
            background={background}
            justify="between"
        >
            <Box overflow="scroll">
                <Box height={{ min: '100%' }} flex={{ shrink: 0 }}>
                    { children }
                </Box>
            </Box>
            {actions}
        </Box>
    );
};

BottomContainer.defaultProps = {
    actions: undefined,
    children: undefined,
    background: '#f3f4f5',
};

export default BottomContainer;
